// extracted by mini-css-extract-plugin
module.exports = {"message":"Web3message_message__3YdLW","account":"Web3message_account__3kw7k","text":"Web3message_text__KjQcv","status":"Web3message_status__Yq6-z"};